document.addEventListener('DOMContentLoaded', function() {
  const banners = document.querySelectorAll('.banner--has-image');
  
  banners.forEach(function(banner) {
    const hasRealImage = banner.querySelector('img:not(.placeholder-image)');
    const hasPlaceholder = banner.querySelector('.placeholder-image, svg[data-aspect-ratio]');
    
    if (!hasRealImage && hasPlaceholder) {
      banner.remove();
    }
  });
});